<template>
  <div class="google-map" ref="googleMap">
    <div >
    </div>
  </div>
</template>

<script>
  import * as GoogleMapsLoader from 'google-maps'

  export default {
    name: 'google-map',
    props: {
      points: {
        type: Array
      },
      initialPoint: {
        type: Object
      },
      origin: {
        type: Object,
        default: null
      },
      destiny: {
        type: Object
      }
    },
    data() {
      return {
        map: null,
        originMarker: null,
      }
    }, 
    watch: {
      origin: function (newVal, oldVal) { // watch it
        let vue = this
        console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        // if (newVal.length > 0) this.draw()
        if (newVal.geometry) {
          vue.map.panTo(newVal.geometry.location);

          // Place a draggable marker on the map
          if (vue.originMarker) {
            vue.originMarker.setMap(null)
            vue.originMarker = null
          }
          vue.originMarker = new google.maps.Marker({
              position: newVal.geometry.location,
              map: vue.map,
              draggable:true,
              title: newVal.name
          })
          vue.map.setZoom(18);
        } else {
          document.getElementById('autocomplete').placeholder = 'Enter a city';
        }
      }
    },
    mounted () {
      let vue = this
      let googleMap = vue.$refs.googleMap
      console.log('googleMap', googleMap)
      GoogleMapsLoader.KEY = 'AIzaSyDFE5IMF4suAO1lsHSrbnFaKs6l1dBljXc'
      GoogleMapsLoader.LIBRARIES = ['geometry', 'places']
      GoogleMapsLoader.LANGUAGE = 'es'
      GoogleMapsLoader.load((google) => {
        /* eslint-disable no-new */
        vue.map = new google.maps.Map(vue.$refs.googleMap, {
          center: vue.initialPoint,
          zoom: 12,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        })
      })
    }
  }
</script>

<style lang="scss">
  .google-map {
    height: 100%;
  }
</style>
